import * as Yup from 'yup';

import { Trainer, TrainerImages } from 'types/trainer';
import { stringArraySchema } from 'validation/stringArraySchema';
import { ImageFields, ImagePreset } from 'types/photo';

export interface TrainerFormValuesProps extends Trainer {}

export enum TRAINER_TAB_VALUES {
  INFO = 'info',
  STYLING = 'styling',
}

export const TrainerSchema = Yup.object().shape({
  name: Yup.string().required('Имя обязательно к заполнению'),
  main: stringArraySchema,
  skills: stringArraySchema,
  awards: stringArraySchema,
  special: stringArraySchema,
});

export const TRAINER_IMAGES_PRESETS: Record<keyof TrainerImages, ImagePreset> = {
  [ImageFields.COVER_MOBILE]: {
    width: 40,
    height: 40,
    title: 'Мобильная версия обложки',
    rounded: true,
  },
  [ImageFields.PHOTO_MOBILE]: {
    width: 800,
    height: 760,
    title: 'Мобильная версия',
  },
  [ImageFields.COVER_DESKTOP]: {
    width: 40,
    height: 40,
    title: 'ПК версия обложки',
    rounded: true,
  },
  [ImageFields.PHOTO_DESKTOP]: {
    width: 1000,
    height: 340,
    title: 'ПК версия',
  },
};
